// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wuxi3","newExpiryDate":"styles_newExpiryDate__QzmyD","footer":"styles_footer__JzYXm"};